import { localePath, getStrings, type Lang } from '../lib/i18n';
import { strings as blogStrings } from '../lib/blog';
import { hubStrings } from '../lib/tools';

// Single source of truth for the top-nav links, so every header (Hero, BlogHeader,
// East vs West) shows the exact same items in the same order. "East vs West" is a
// brand name and stays a literal string; the rest are localized.
export function siteNavItems(lang: Lang): { href: string; label: string }[] {
  const c = getStrings(lang);
  return [
    { href: localePath(lang, '/'), label: blogStrings[lang].home },
    { href: localePath(lang, '/east-vs-west'), label: 'East vs West' },
    { href: localePath(lang, '/blog'), label: blogStrings[lang].blog },
    { href: localePath(lang, '/armwrestling/exercises'), label: c.exercisesChrome.navLabel },
    { href: localePath(lang, '/armwrestling/equipment'), label: c.equipmentChrome.navLabel },
    { href: localePath(lang, '/tools'), label: hubStrings(lang).navLabel },
  ];
}

export function SiteNav({
  lang,
  linkClassName = 'rounded-full px-3 py-2 text-sm font-bold text-muted hover:text-[var(--brand-ink)] hover:bg-[var(--brand-soft)] transition-colors whitespace-nowrap',
}: {
  lang: Lang;
  linkClassName?: string;
}) {
  return (
    <>
      {siteNavItems(lang).map((i) => (
        <a key={i.href} href={i.href} className={linkClassName}>
          {i.label}
        </a>
      ))}
    </>
  );
}
